<template>
    <div class="program" ref="programRef">
        <!-- 筛选 -->
        <div class="program-form sticky">
            <a-spin :spinning="filterLoading" tip="Loading...">
                <a-form class="filter-form" layout="inline">
                    <a-form-item :label="$t('web.name' /* 姓名 */)">
                        <a-input style="width: 150px" v-model="querySearch.real_name" />
                    </a-form-item>
                    <a-form-item :label="$t('web.company' /* 单位 */)">
                        <a-input style="width: 150px" v-model="querySearch.org" />
                    </a-form-item>
                    <a-form-item :label="$t('program.title' /* 标题 */)">
                        <a-input style="width: 150px" v-model="querySearch.title" />
                    </a-form-item>
                    <a-form-item :label="$t('program.speech_type' /* 发言类型 */)">
                        <a-select style="width: 150px" v-model="querySearch.type">
                            <a-select-option v-for="item in fayanList" :value="item.id" :key="item.id">{{ item['typename_' + $route.params.lang] }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="handleSearchEvent">{{ $t('web.query' /* 查询 */) }}</a-button>
                    </a-form-item>
                </a-form>
                <div class="filter-tab mt15 flex x-left y-top">
                    <span class="mt5 filter-tab-label">{{ $t('web.date' /* 日期 */) }}</span>
                    <a-button icon="plus" type="dashed" @click="handleAddDateClickEvent">{{ $t('program.add_date_button' /* 添加日期 */) }}</a-button>
                    <div class="flex-item flex x-left y-top">
                        <a class="filter-tab-item first-item" @click="dateCurrent = 0" :class="{ selected: dateCurrent == 0 }" href="javascript:;">{{ $t('program.all_option' /* 全部 */) }}</a>
                        <div class="flex x-left flex-item flex-wrap">
                            <a-popover :title="false" v-for="(item, index) in dateList" :key="item.id" placement="top">
                                <template slot="content">
                                    <a-icon class="fs18" style="padding: 5px; cursor: pointer" type="edit" @click="handleAddDateClickEvent(item)" />
                                    <a-icon class="fs18" @click="handleFilterDelete(item.id, index, 'date')" style="padding: 5px; cursor: pointer" type="delete" />
                                </template>
                                <a class="filter-tab-item" @click="dateCurrent = item.id" :class="{ selected: dateCurrent == item.id }" href="javascript:;">{{ item.meeting_date }}</a>
                            </a-popover>
                        </div>
                    </div>
                </div>
                <div class="filter-tab mt10 flex x-left y-top">
                    <span class="mt5 filter-tab-label">{{ $t('program.batch_live_label_hall' /* 会场 */) }}</span>
                    <a-button icon="plus" type="dashed" @click="handleAddHallClickEvent">{{ $t('program.add_hall_button' /* 添加会场 */) }}</a-button>
                    <div class="flex-item flex x-left y-top">
                        <a class="filter-tab-item first-item" @click="hallCurrent = 0" :class="{ selected: hallCurrent == 0 }" href="javascript:;">{{ $t('program.all_option' /* 全部 */) }}</a>
                        <draggable class="flex-item" v-model="hallList" @change="handleDraggable('hallList')" :move="handleDragMoveEvent" filter=".not-drag">
                            <transition-group class="flex x-left flex-wrap">
                                <a-popover :title="false" v-for="(item, index) in hallList" :key="item.id" placement="top">
                                    <template slot="content">
                                        <a-icon class="fs18" style="padding: 5px; cursor: pointer" type="edit" @click="handleAddHallClickEvent(item)" />
                                        <a-icon class="fs18" @click="handleFilterDelete(item.id, index, 'hall')" style="padding: 5px; cursor: pointer" type="delete" />
                                    </template>
                                    <a class="filter-tab-item drag-item" @click="hallCurrent = item.id" :class="{ selected: hallCurrent == item.id }" href="javascript:;">{{ item.meeting_hall }}</a>
                                </a-popover>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
                <div class="filter-tab mt10 flex x-left y-top">
                    <span class="mt5 filter-tab-label">{{ $t('program.special_forum_label' /* 专题分论坛 */) }}</span>
                    <a-button icon="plus" type="dashed" @click="handleAddClassClickEvent">{{ $t('program.add_special_forum_button' /* 添加专题分论坛 */) }}</a-button>
                    <div class="flex-item flex x-left y-top">
                        <a class="filter-tab-item first-item" @click="xuezuCurrent = 0" :class="{ selected: xuezuCurrent == 0 }" href="javascript:;">{{ $t('program.all_option' /* 全部 */) }}</a>
                        <draggable class="flex-item" v-model="xuezuList" @change="handleDraggable('xuezuList')" :move="handleDragMoveEvent" filter=".not-drag">
                            <transition-group class="flex x-left flex-wrap">
                                <a-popover :title="false" v-for="(item, index) in xuezuList" :key="item.id" placement="top">
                                    <template slot="content">
                                        <a-icon class="fs18" style="padding: 5px; cursor: pointer" type="edit" @click="handleAddClassClickEvent(item)" />
                                        <a-icon class="fs18" @click="handleFilterDelete(item.id, index, 'xuezu')" style="padding: 5px; cursor: pointer" type="delete" />
                                    </template>
                                    <a class="filter-tab-item drag-item" @click="xuezuCurrent = item.id" :class="{ selected: xuezuCurrent == item.id }" href="javascript:;">{{ item.class_cnname }}</a>
                                </a-popover>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
            </a-spin>
        </div>
        <!-- 操作 -->
        <div class="flex mt15 sticky x-between y-top">
            <a href="javascript:;" @click="$refs.sessionUpdateDrawerRef.show()" style="margin-top: 8px" class="flex x-left color000 y-center">
                <b style="line-height: 1">{{ $t('program.all_units' /* 全部单元 */) }}</b>
                <a-tooltip destroyTooltipOnHide>
                    <template slot="title">{{ $t('program.add_unit' /* 添加单元 */) }}</template>
                    <a-icon class="fs18 ml5" type="plus-circle" />
                </a-tooltip>
            </a>
            <div class="flex-item flex x-right">
                <a-space class="x-right" style="flex-wrap: wrap">
                    <a-button @click="$refs.exportProModalRef.show()" class="mt5" ghost type="primary">{{ $t('program.export_program_modal' /* 导出日程 */) }}</a-button>
                    <a-button @click="handleGoProgramEvent('cn')" class="mt5" ghost type="primary">{{ $t('program.view_program_cn' /* 查看日程(中文页面) */) }}</a-button>
                    <a-button @click="handleGoProgramEvent('en')" class="mt5" ghost type="primary">{{ $t('program.view_program_en' /* 查看日程(英文页面) */) }}</a-button>
                    <a-button class="mt5" ghost type="primary">{{ $t('program.upload_video_drawer' /* 视频上传管理 */) }}</a-button>
                    <a-button @click="handleClearPragramEvent" class="mt5" ghost type="danger">{{ $t('program.clear_cache' /* 清空日程缓存 */) }}</a-button>
                    <a-dropdown class="mt5">
                        <a-button type="primary" style="margin-left: 8px">
                            {{ $t('program.more_operations' /* 更多操作 */) }}
                            <a-icon type="down" />
                        </a-button>
                        <a-menu slot="overlay">
                            <a-menu-item key="1">
                                <a href="javascript:;" @click="$refs.repeatListDrawerRef.show(programList)" class="mt5" size="small" type="primary">
                                    {{ $t('program.repeat_list_drawer' /* 日程时间冲突查重 */) }}
                                </a>
                            </a-menu-item>
                            <a-menu-item key="2">
                                <a href="javascript:;" @click="$refs.unplannedListDrawerRef.show()" class="mt5" size="small" type="primary">
                                    {{ $t('program.unplanned_list_drawer' /* 已评审未排进日程文章 */) }}
                                </a>
                            </a-menu-item>
                            <a-menu-item key="3">
                                <a href="javascript:;" @click="$refs.programLogsDrawerRef.show()" class="mt5" size="small" type="primary">
                                    {{ $t('program.program_logs_drawer' /* 查看日程更新记录 */) }}
                                </a>
                            </a-menu-item>
                            <a-menu-item key="4">
                                <a href="javascript:;" @click="$refs.batchLiveRef.show(xuezuCurrent)" class="mt5" size="small" type="primary">
                                    {{ $t('program.batch_live_modal' /* 批量设置直播备注 */) }}
                                </a>
                            </a-menu-item>
                            <a-menu-item key="5">
                                <a href="javascript:;" @click="$refs.batchSessionDrawerRef.show()" class="mt5" size="small" type="primary">
                                    {{ $t('program.batch_session_drawer' /* 批量修改Session信息 */) }}
                                </a>
                            </a-menu-item>
                            <a-menu-item key="6">
                                <a href="javascript:;" @click="$refs.unplannedMemDrawerRef.show()" class="mt5" size="small" type="primary">
                                    {{ $t('program.unplanned_members_drawer' /* 查看未安排学术任务委员名单 */) }}
                                </a>
                            </a-menu-item>
                            <a-menu-item key="7">
                                <a href="javascript:;" @click="$refs.importProgramDrawerRef.show()" class="mt5" size="small" type="primary">{{ $t('program.import_program' /* 日程导入 */) }}</a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </a-space>
            </div>
        </div>
        <!-- 日程表格内容 -->
        <div class="program-table mt15">
            <!-- 日程表格表头 -->
            <div class="program-table-header">
                <div class="tr-item flex x-left">
                    <div class="th-item">
                        {{ $t('program.hall_date_header' /* 会场/日期 */) }}
                        <a-dropdown>
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()">{{ $t('program.quick_switch_hall' /* 快速切换会场 */) }}</a>
                            <a-menu slot="overlay">
                                <a-menu-item @click="handleFixedTargetEvent(`hallElement_${item.id}`)" v-for="item in hallList" :key="item.id">
                                    <a href="javascript:;">{{ item.meeting_hall }}</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                    <template v-for="item in dateList">
                        <div v-if="dateCurrent == 0 || dateCurrent == item.id" :key="item.id" class="th-item">{{ item.meeting_date }}</div>
                    </template>
                </div>
            </div>
            <!-- 日程表格内容 -->
            <div class="program-table-body">
                <a-spin :spinning="contentLoading" tip="Loading...">
                    <template v-for="item in hallList">
                        <div :id="`hallElement_${item.id}`" v-if="hallCurrent == 0 || hallCurrent == item.id" :key="item.id" class="tr-item flex x-left">
                            <div class="td-item" style="justify-content: center">{{ item.meeting_hall }}</div>
                            <template v-for="it in dateList">
                                <div :key="it.id" v-if="dateCurrent == 0 || dateCurrent == it.id" class="td-item">
                                    <a-timeline v-if="((programList[item.id] || {})[it.id] || [])?.length">
                                        <a-timeline-item v-for="(n, i) in programList[item.id][it.id]" :key="i" :color="n.colour">
                                            <b :style="{ color: n.colour }">{{ n.starttime_slot }} - {{ n.endtime_slot }}</b>
                                            <card-item
                                                @session="$refs.childSessionDrawerRef.show(n, programList[item.id][it.id])"
                                                @edit="$refs.sessionUpdateDrawerRef.show(n)"
                                                @change-color="handleColorChange($event, item.id, it.id, i)"
                                                @remove="handleSessionRemove(item.id, it.id, i)"
                                                :data-info="n"
                                            ></card-item>
                                        </a-timeline-item>
                                    </a-timeline>
                                    <a-button @click="$refs.sessionUpdateDrawerRef.show({ date_id: it.id, hall_id: item.id })" icon="plus" class="btn-hover" type="dashed">
                                        {{ $t('program.add_academic_unit_button' /* 添加学术单元 */) }}
                                    </a-button>
                                </div>
                            </template>
                        </div>
                    </template>
                </a-spin>
            </div>
        </div>

        <!-- 编辑日期弹窗 -->
        <date-update-modal ref="dateUpdateRef" @closeDateUpdate="refreshFilterListFun('date')" :title="$t('program.edit_date_modal' /* 编辑日期弹窗 */)" />
        <!-- 编辑专题分论坛弹窗 -->
        <class-update-modal ref="classUpdateRef" @closeClassUpdate="refreshFilterListFun('xuezu')" :title="$t('program.edit_special_forum_modal' /* 编辑专题分论坛弹窗 */)" />
        <!-- 编辑会场坛弹窗 -->
        <hall-update-modal ref="hallUpdateRef" @closeHallUpdate="refreshFilterListFun('hall')" :title="$t('program.edit_hall_modal' /* 编辑会场坛弹窗 */)" />
        <!-- 日程时间冲突查重 -->
        <repeat-list-drawer ref="repeatListDrawerRef" :title="$t('program.repeat_list_drawer' /* 日程时间冲突查重 */)" :dateList="dateList" :hallList="hallList" :xuezuList="xuezuList" />
        <!-- 子session -->
        <childSessionDrawer
            ref="childSessionDrawerRef"
            @refresh="getProgramList"
            @open-sub-session="handleOpenSubSession"
            :dateList="dateList"
            :hallList="hallList"
            :xuezuList="xuezuList"
            :title="$t('program.meeting_session_management' /* 会议日程管理 */)"
        />
        <!-- 子session - 用于递归弹出 -->
        <childSessionDrawer
            ref="subChildSessionDrawerRef"
            @refresh="getProgramList"
            @open-sub-session="handleOpenSubSession"
            :dateList="dateList"
            :hallList="hallList"
            :xuezuList="xuezuList"
            :title="$t('program.child_session_management' /* 子日程管理 */)"
            :is-sub="true"
        />
        <!-- 编辑日程 -->
        <sessionUpdateDrawer
            :dateList="dateList"
            :hallList="hallList"
            :xuezuList="xuezuList"
            @refresh="getProgramList"
            ref="sessionUpdateDrawerRef"
            :title="$t('program.edit_session_drawer' /* 编辑日程 */)"
        />
        <!-- 已评审未排进日程文章 -->
        <unplanned-list-drawer ref="unplannedListDrawerRef" :fayanList="fayanList" :title="$t('program.unplanned_list_drawer' /* 已评审未排进日程文章 */)" />
        <!-- 导出日程 -->
        <export-program-modal ref="exportProModalRef" :dateList="dateList" :hallList="hallList" :xuezuList="xuezuList" :title="$t('program.export_program_modal' /* 导出日程 */)" />
        <!-- 查看日程更新记录 -->
        <program-logs-drawer ref="programLogsDrawerRef" :title="$t('program.program_logs_drawer' /* 查看日程更新记录 */)" />
        <!-- 批量设置直播备注 -->
        <batch-live-modal
            ref="batchLiveRef"
            :dateList="dateList"
            :hallList="hallList"
            :xuezuList="xuezuList"
            @closeBatchLive="getProgramList"
            :title="$t('program.batch_live_modal' /* 批量设置直播备注 */)"
        />
        <!-- 批量修改Session信息 -->
        <batch-session-drawer ref="batchSessionDrawerRef" :dateList="dateList" :hallList="hallList" :title="$t('program.batch_session_drawer' /* 批量修改Session信息 */)" />
        <!-- 查看未安排学术任务委员名单 -->
        <unplanned-members-drawer ref="unplannedMemDrawerRef" :title="$t('program.unplanned_members_drawer' /* 查看未安排学术任务委员名单 */)" />
        <!-- 视频上传管理 -->
        <upload-video-drawer ref="uploadVideoDrawerRef" :title="$t('program.upload_video_drawer' /* 视频上传管理 */)" />
        <!-- 日程导入 -->
        <import-program-drawer ref="importProgramDrawerRef" />
    </div>
</template>

<script>
import cardItem from './components/card-item.vue';
import draggable from 'vuedraggable';
import dateUpdateModal from './components/date-update-modal.vue';
import classUpdateModal from './components/class-update-modal.vue';
import hallUpdateModal from './components/hall-update-modal.vue';
import repeatListDrawer from './components/repeat-list-drawer.vue';
import childSessionDrawer from './components/child-session-drawer.vue';
import unplannedListDrawer from './components/unplanned-list-drawer.vue';
import exportProgramModal from './components/export-program-modal.vue';
import sessionUpdateDrawer from './components/session-update-drawer.vue';
import programLogsDrawer from './components/program-logs-drawer.vue';
import batchLiveModal from './components/batch-live-modal.vue';
import batchSessionDrawer from './components/batch-session-drawer.vue';
import unplannedMembersDrawer from './components/unplanned-members-drawer.vue';
import uploadVideoDrawer from './components/upload-video-drawer.vue';
import importProgramDrawer from './components/import-program-drawer.vue';

export default {
    name: 'ProgramIndex',
    components: {
        cardItem,
        draggable,
        dateUpdateModal,
        classUpdateModal,
        hallUpdateModal,
        repeatListDrawer,
        childSessionDrawer,
        unplannedListDrawer,
        exportProgramModal,
        programLogsDrawer,
        batchLiveModal,
        batchSessionDrawer,
        unplannedMembersDrawer,
        sessionUpdateDrawer,
        uploadVideoDrawer,
        importProgramDrawer
    },
    props: {},
    data() {
        return {
            // 筛选
            filterLoading: false,
            // 内容
            contentLoading: false,
            querySearch: {
                real_name: '',
                org: '',
                title: '',
                type: ''
            },
            // 日期
            dateList: [],
            dateCurrent: 0,
            // 会场
            hallList: [],
            hallCurrent: 0,
            // 学组
            xuezuList: [],
            xuezuCurrent: 0,
            // 发言
            fayanList: [],
            // 日程列表
            programList: {},
            lang: this.$route.params.lang
        };
    },
    watch: {
        dateCurrent() {
            // this.getProgramList();
        },
        hallCurrent() {
            // this.getProgramList();
        },
        xuezuCurrent() {
            this.getProgramList();
        }
    },
    methods: {
        // 拖拽排序
        handleDraggable(field) {
            let list = this[field];
            let type = 1; // 1.学组类型 2.会场排序
            if (field == 'hallList') {
                type = 2;
            }
            let idx = list.map(it => it?.id);
            let idsString = idx.join(',');
            this.$request.post({ url: 'sortProgramOrderBy', data: { cid: idsString, type } }).then(() => {
                this.$message.success(this.$t('program.sort_success' /* 排序成功 */));
            });
        },
        // 拖动中
        handleDragMoveEvent(e) {
            if (!e.relatedContext.element?.id) {
                return false;
            }
            return true;
        },

        // 删除筛选
        handleFilterDelete(cid, index, type) {
            this.$confirm({
                title: this.$t('web.tips' /* 温馨提示 */),
                content: this.$t('web.del_current' /* 确认删除该项吗？ */),
                onOk: () => {
                    let url = '';
                    let field = '';
                    if (type == 'date') {
                        url = 'deleteProgramDate';
                        field = 'dateList';
                    }
                    if (type == 'hall') {
                        url = 'deleteProgramHall';
                        field = 'hallList';
                    }
                    if (type == 'xuezu') {
                        url = 'deleteProgramClass';
                        field = 'xuezuList';
                    }
                    this.$request.post({ url, data: { cid } }).then(res => {
                        this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                        this[field].splice(index, 1);
                    });
                }
            });
        },

        // 监听滚动条滚动
        listenScrollFun() {
            const scrollElement = document.querySelector('.program'); //你的需要滚动的标签
            const targetElement = document.querySelector('.program-table'); //滚动区域

            let isDragging = false;
            let startX, startY, scrollLeft, scrollTop;

            targetElement.addEventListener('mousedown', e => {
                isDragging = true;
                startX = e.pageX - scrollElement.offsetLeft;
                startY = e.pageY - scrollElement.offsetTop;
                scrollLeft = scrollElement.scrollLeft;
                scrollTop = scrollElement.scrollTop;
                scrollElement.style.cursor = 'grabbing';
            });

            targetElement.addEventListener('mouseleave', () => {
                isDragging = false;
                scrollElement.style.cursor = 'grab';
            });

            targetElement.addEventListener('mouseup', () => {
                isDragging = false;
                scrollElement.style.cursor = 'grab';
            });

            targetElement.addEventListener('mousemove', e => {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.pageX - scrollElement.offsetLeft;
                const y = e.pageY - scrollElement.offsetTop;
                const walkX = (x - startX) * 2; // 调整滚动速度
                const walkY = (y - startY) * 2; // 调整滚动速度
                scrollElement.scrollLeft = scrollLeft - walkX;
                scrollElement.scrollTop = scrollTop - walkY;
            });
        },

        // 滚动到会场区域
        handleFixedTargetEvent(hallElement) {
            document.getElementById(hallElement).scrollIntoView({ behavior: 'smooth' });
        },

        // 获取日程列表
        getProgramList() {
            this.contentLoading = true;
            this.$request
                .get({ url: 'getProgramSessionList', data: { date_id: this.dateCurrent, hall_id: this.hallCurrent, xuezu_id: this.xuezuCurrent } })
                .then(res => {
                    this.programList = res.data;
                })
                .finally(() => {
                    this.contentLoading = false;
                });
        },

        // 页面初始化
        pageInit() {
            this.filterLoading = true;
            Promise.all([
                this.$request.get({ url: 'getProgramDateList' }),
                this.$request.get({ url: 'getProgramHallList' }),
                this.$request.get({ url: 'getProgramXuezuList' }),
                // 下拉筛选数据
                this.$request.get({ url: 'getProgramFayanList', data: { type: 2 } })
            ])
                .then(res => {
                    this.dateList = res[0].data;
                    this.hallList = res[1].data;
                    this.xuezuList = res[2].data;
                    this.fayanList = res[3].data;
                })
                .finally(() => {
                    this.filterLoading = false;
                });
        },
        /**
         * ## 添加/编辑日期
         */
        handleAddDateClickEvent(item) {
            this.$refs.dateUpdateRef.show(item);
        },
        /**
         * ## 编辑专题分论坛
         */
        handleAddClassClickEvent(item) {
            this.$refs.classUpdateRef.show(item);
        },
        /**
         * ## 编辑会场
         */
        handleAddHallClickEvent(item) {
            this.$refs.hallUpdateRef.show(item);
        },
        /**
         * 刷新筛选条件列表
         * @param type
         */
        refreshFilterListFun(type) {
            switch (type) {
                case 'date':
                    this.$request.get({ url: 'getProgramDateList' }).then(res => {
                        this.dateList = res.data;
                    });
                    break;
                case 'hall':
                    this.$request.get({ url: 'getProgramHallList' }).then(res => {
                        this.hallList = res.data;
                    });
                    break;
                case 'xuezu':
                    this.$request.get({ url: 'getProgramXuezuList' }).then(res => {
                        this.xuezuList = res.data;
                    });
                    break;
            }
        },
        /**
         * ## 查询日程
         */
        handleSearchEvent() {
            this.$router.push({
                path: `/program/task/${this.$route.params.lang}/${this.$route.params.meeting_id}`,
                query: {
                    name: this.querySearch.real_name,
                    title: this.querySearch.title,
                    org: this.querySearch.org,
                    type: this.querySearch.type
                }
            });
        },
        /**
         * 颜色改变事件
         */
        handleColorChange(color, hall_id, date_id, index) {
            this.$set(this.programList[hall_id][date_id][index], 'colour', color);
        },
        /**
         * session删除事件
         */
        handleSessionRemove(hall_id, date_id, index) {
            this.programList[hall_id][date_id].splice(index, 1);
        },
        /**
         * ## 跳转查看日程
         * @param type
         */
        handleGoProgramEvent(type) {
            window.open(`${this.$store.getters.m_base_url}/${type}/web/program/${this.$route.params.meeting_id}`, '_blank');
        },
        // 清空日程缓存
        handleClearPragramEvent() {
            this.$request.post({ url: 'clearPragramCache' }).then(res => {
                this.$message.success(res.message);
            });
        },
        /**
         * 处理子日程弹出事件
         */
        handleOpenSubSession(record, sessionList) {
            // 使用新的抽屉实例，保持当前抽屉打开
            this.$refs.subChildSessionDrawerRef.show(record, sessionList);
        }
    },
    mounted() {
        this.listenScrollFun();
        this.pageInit();
        this.getProgramList();
    }
};
</script>
<style lang="less" scoped>
.program {
    position: absolute;
    left: 0;
    width: 100%;
    height: calc(100vh - 138px);
    overflow: auto;
}
.sticky {
    position: sticky;
    left: 0;
    top: -99999px;
}
.program-form {
    padding-bottom: 15px;
    border-bottom: 1px dashed #ddd;
}
.filter-form {
    background-color: #fafafa;
    border: 1px solid #eee;
    border-radius: 3px;
    padding: 10px 15px;
}
.filter-tab {
    &-label {
        flex: 0 0 80px;
        text-align: justify;
        text-align-last: justify;
        position: relative;
        padding-right: 10px;
        &::after {
            content: ':';
            position: absolute;
            right: 6px;
            margin: 0;
        }
    }
    &-item {
        padding: 9px 10px;
        line-height: 1;
        display: inline-block;
        border: 1px solid transparent;
        margin-bottom: 6px;
        border-radius: 3px;
        color: #333;
        background-color: #fff;
        &.selected {
            color: #4d9ff8;
            font-weight: bold;
        }
        &:not(.first-item):hover {
            border: 1px dashed #959595;
            color: #333;
        }
    }
    .drag-item:hover {
        position: relative;
        &:after {
            position: absolute;
            left: 0;
            bottom: -15px;
            width: 100%;
            text-align: center;
            font-size: 10px;
            color: #999;
            content: '拖动排序';
        }
    }
}
.program-table {
    width: 100%;
    background-color: #fff;
    &-header {
        position: sticky;
        top: 1px;
        z-index: 9;
    }
    .tr-item {
        width: 100%;
        flex-wrap: nowrap;
        .td-item,
        .th-item {
            flex: 1;
            position: relative;
            min-width: 250px;
            padding: 10px 15px;
            background-color: #fff;
            border: 1px solid #ddd;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &:first-child {
                background-color: #fff !important;
                color: #000 !important;
                font-weight: bold;
            }
        }
        .td-item {
            min-height: 200px;
            padding: 25px 15px 15px 15px;
            padding-bottom: 60px;
            .btn-hover {
                display: none;
                position: absolute;
                left: 15px;
                bottom: 15px;
                right: 15px;
            }
            &:hover .btn-hover {
                display: block;
            }
        }
        // 字号通用类名
        @colors: #5181f1, #1b99a1, #e89724, #6f2189, #c42652, #97c042;
        each(@colors,{
            .th-item:nth-child(6n+@{key}){
                // background-color: lighten(@currColor, @currBgColor);
                background:@value;
                color:#fff;
            }
        });
    }
    .ant-dropdown-link {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 35px;
        background-color: #f7f9ff;
        border-bottom-right-radius: 10px;
        border: 1px solid #ddd;
        text-align: center;
        line-height: 35px;
        color: #333;
        z-index: 99;
        font-weight: normal;
    }
}
</style>
